import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  assetDataService,
  praSharedModelService,
} from 'app/services';
import { alerts, actionIcon, ssAutocomplete } from 'app/components/global';
import asset from 'app/components/admin/assetAdministration/asset';
import editAssetDialog from 'app/components/admin/assetAdministration/dialog.editAssetDialog';
import uniqueProcessNameValidator from '../validators/process-unique-name.validator.directive';
import controller from './edit-process-dialog.controller';
import template from './edit-process-dialog.html';
import messages from './messages/process.appetite.messages.html';
import assignAssetDialog from '../dialog.assignAssetDialog';

class dialogService {
  getOptions($event, {
    customerId = 0,
    process = {
      processId: 0,
      canEditProcess: true
    },
    assetsByType,
    assignedAssets,
    assetTypes,
    customerRiskAppetiteLevels,
    updateCallBack
  }) {
    return {
      controller,
      controllerAs: 'editProcessDialogVM',
      locals: {
        customerId,
        process,
        assetsByType,
        assignedAssets,
        assetTypes,
        customerRiskAppetiteLevels,
        updateCallBack
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pra.editPraProcessDialog', [
  ssDialogService,
  alerts,
  actionIcon,
  loaderService,
  editAssetDialog,
  ssAutocomplete,
  asset,
  assignAssetDialog,
  assetDataService,
  praSharedModelService,
])
  .service('editPraProcessDialog', dialogService)
  .directive('emProcessUniqueName', uniqueProcessNameValidator)
  .run(($templateCache) => {
    $templateCache.put('process.appetite.messages.html', messages);
  })
  .name;

console.log('app.components.advisory.pra.editPraProcessDialog created');
